export default "__VITE_ASSET__DfpYLuKo__"